import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import DatePicker from "../../../../../../common/datePicker";
import { convertDigitToEnglish } from "./../../../../../../method/convertDigitToEnglish";


let useStyles = makeStyles((theme) => ({
    root: {
        width: "270px",
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box: {
        margin: 10,
        [theme.breakpoints.down("700")]: {
            margin: '10px 0px',
            width: '100%',
        },
    }
}))

export default function Index({ handleChange, state }) {

    let classes = useStyles();


    const handelChangeDate = (data, type) => {

        let date = convertDigitToEnglish(data?.format("YYYY/MM/DD"));
        date = `${date} 00:00:00.000000`;

        handleChange(date, type)

    };

    return (
        <div className={classes['root']}>
            <Box
                className={classes['box']}
                // marginBottom="30px"
                width="250px"
                height="50px"
            >
                <DatePicker
                    label="از تاریخ"
                    value={
                        state?.['from_date']?.includes("undefined")
                            ? null
                            : state?.['from_date']
                    }
                    setValue={(data) => handelChangeDate(data, "from_date")}
                />
            </Box>
        </div>
    )
}



